interface SectionHeaderProps {
  icon?: string;
  title: string;
  actionLabel?: string;
  actionHref?: string;
}

function SectionHeader({
  icon,
  title,
  actionLabel = "Ver todas",
  actionHref = "#ver-todas"
}: SectionHeaderProps) {
  return (
    <div className="section-header">
      <h2>
        {icon && <span className="section-icon">{icon}</span>} {title}
      </h2>
      <a href={actionHref}>{actionLabel}</a>
    </div>
  );
}

export default SectionHeader;
